import NiotaClassicApiService from '@/services/niotaClassicApiService';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
import cloneDeep from 'lodash/cloneDeep';
import ApiService from '@/services/apiService';
export default {
  name: 'NiotaClassicConsumersForm',
  mixins: [formMixin],
  props: {
    isOpen: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      titleRules: [v => !!v || this.$i18n_t('Common.fieldRequired')],
      consumerCanBeEdited: true,
      plainAccounts: [],
      consumerTypes: ['MQTT', 'Websocket', 'Webhook', 'Azure'],
      isIEC104IntegrationActive: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    statusItems() {
      return ['public', 'private'].map(s => {
        return {
          text: this.$i18n_t(`NiotaClassic.DataSources.form.status_${s}`),
          value: s
        };
      });
    }
  },
  watch: {},
  created() {
    this.formItem = cloneDeep(this.editedItem);
    this.getPlainAccounts();
    // In create case:
    if (!this.formItem.accountId) {
      this.formItem.accountId = this.$store.state.authentication.tenantId;
    }
    this.checkAccountIEC104Integration(this.formItem.accountId);
  },
  methods: {
    createRequest() {
      this.formItem.applications = [];
      this.formItem.options = {};
      if (this.formItem.type === 'IEC-60870-5-104') {
        this.formItem.options.dataPoints = [];
        this.formItem.options.clientWhitelist = [];
      }
      return NiotaClassicApiService.consumersCreate(this.formItem);
    },
    getPlainAccounts() {
      NiotaClassicApiService.accountsFetchPlain().then(res => {
        this.plainAccounts = res.data.accounts;
      }).catch(() => {
        this.$snack(this.$i18n_t('Common.errorFetchingAccounts'), 'error');
      });
    },
    checkAccountIEC104Integration(accountId) {
      ApiService.getVersionDriftAccountIntegrations(accountId).then(res => {
        this.isIEC104IntegrationActive = res.find(integration => integration.type === 'iec104');
        this.updateConsumerTypesArray();
      }).catch(err => console.error(err));
    },
    updateConsumerTypesArray() {
      const iec104 = 'IEC-60870-5-104';
      const iec104Index = this.consumerTypes.indexOf(iec104);
      if (this.isIEC104IntegrationActive) {
        // if the IEC104 active and it is not listed, add it to the list
        if (iec104Index === -1) {
          this.consumerTypes.push(iec104);
        }
      } else {
        // if the IEC104 not active and it is listed, remove it from the list
        if (iec104Index !== -1) {
          this.consumerTypes.splice(iec104Index);
        }
      }
    }
  }
};